import { CheckTriangleIcon } from "assets/icons";
import cn from "classnames";
import {
  removeElementInArrayByIndex,
  replaceElementInArray
} from "helpers/methods";
import { t } from "i18next";
import find from "lodash/find";
import findIndex from "lodash/findIndex";
import { Icon } from "ui";
import { FormField } from "ui/FormField";

import { SelectableListProps } from "./SelectableList.types";

import styles from "./SelectableList.module.scss";

const SelectableList = ({
  values,
  onChange,
  options,
  label,
  errorMessage
}: SelectableListProps) => {
  const findSelectableItem = (value: string) => {
    return find(values, { value });
  };

  const toggleSelectableItem = (value: string) => {
    return () => {
      const selectableItem = findSelectableItem(value);

      if (selectableItem) {
        const selectableItemIndex = findIndex(values, { value });

        const updatedSelectableItem = {
          ...selectableItem,
          delete: !selectableItem.delete
        };

        return onChange(
          selectableItem?.id
            ? replaceElementInArray(
                values,
                updatedSelectableItem,
                selectableItemIndex
              )
            : removeElementInArrayByIndex(values, selectableItemIndex)
        );
      }
      onChange([...values, { value }]);
    };
  };

  return (
    <FormField label={label} errorMessage={errorMessage}>
      <div className={styles["selectable-list"]}>
        {options.map(
          ({ label: optionLabel, value, color = null, disabled = false }) => {
            const selectableItem = findSelectableItem(value);

            const isSelectedItem = selectableItem && !selectableItem.delete;

            return (
              <button
                type="button"
                key={value}
                className={cn(styles["selectable-list__item"], {
                  [styles["selectable-list__item-selected"]]: isSelectedItem
                })}
                onClick={toggleSelectableItem(value)}
                disabled={disabled}
              >
                {isSelectedItem ? (
                  <div
                    className={styles["selectable-list__item--selected-icon"]}
                  >
                    <Icon as={CheckTriangleIcon} />
                  </div>
                ) : null}

                {color ? (
                  <div
                    className={cn(styles["selectable-list__item--color"], {
                      [styles["selectable-list__item--color-white"]]:
                        value.toLowerCase() === "white"
                    })}
                    style={{ background: color }}
                  />
                ) : null}
                {typeof optionLabel === "string" ? t(optionLabel) : optionLabel}
              </button>
            );
          }
        )}
      </div>
    </FormField>
  );
};

export default SelectableList;
